import React, { useEffect, useState } from 'react';
import { BaSeDialogContext } from '@base/react';
import { useApp } from '../../context/app';
import { AtendimentosSSEService } from './services/AtendimentosSSEService';
// import { useApp } from '../../context/app';

export default (props) => {
    const { filtersDashboard, setFiltersDashboard } = useApp();

    const { showModal } = React.useContext(BaSeDialogContext);
    const [pendants, setPendants] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [filters, setFilters] = useState({});
    const [filterOptions, setFilterOptions] = useState({});
    const [filterOptionsConsolidado, setFilterOptionsConsolidado] = useState({});
    const [filtersSelectedValues, setFiltersSelectedValues] = React.useState();

    const [isCPF, setIsCPF] = React.useState(false);
    const [isALL, setIsALL] = React.useState(true);
    const [isCNPJ, setIsCNPJ] = React.useState(false);

    const [isErroSAS, setIsErroSAS] = React.useState(false);
    const [isntErroSAS, setIsntErroSAS] = React.useState(false);
    const [allSAS, setAllSAS] = React.useState(true);

    const [cidades, setCidades] = React.useState([]);
    const [regionais, setRegionais] = React.useState([]);
    const [canaisDigitais, setCanaisDigitais] = React.useState([]);
    const [acoes, setAcoes] = React.useState([]);
    const [solucoes, setSolucoes] = React.useState([]);

    const [cnaesFiltered, setCnaesFiltered] = React.useState([]);

    const [inputSearchValue, setInputSearchValue] = useState('');
    const [paginationFilters, setPaginationFilters] = useState({
        page: 0,
        linesPerPage: 10,
        orderBy: 'id',
        direction: 'DESC',
    });

    const onLinesPerPageChange = (value) => {
        setPaginationFilters({
            ...paginationFilters,
            linesPerPage: value,
            page: 0,
        });
    };

    const handlePageChange = (value) => {
        setPaginationFilters({
            ...paginationFilters,
            page: value,
        });
    };

    const handleOrderClick = ({ orderBy, direction }) => {
        setPaginationFilters({
            ...paginationFilters,
            orderBy: orderBy,
            direction: direction,
        });
    };

    const handleInputPageChange = (newValue) => {
        setPaginationFilters({
            ...paginationFilters,
            page: newValue,
        });
    };

    const handleFilterByStatus = (status) => {
        if (JSON.stringify(status) === JSON.stringify(filters?.status)) {
            setFilters((f) => ({ ...f, status: null }));
            return;
        }
        setFilters((f) => ({ ...f, status: status }));
        setPaginationFilters({
            ...paginationFilters,
            page: 0,
        });
    };

    const updateSelectedValues = (nameFilter, value) => {
        setFiltersSelectedValues(prevFiltersSelectedValues => ({
            ...prevFiltersSelectedValues,
            [nameFilter]: value
        }));
    };

    const cleanSelectedFiltersFromModel = () => {
        setCidades([]);
        setIsALL(true);
        setAllSAS(true);
        setIsCPF(false);
        setIsCNPJ(false);
        setIsErroSAS(false);
        setIsntErroSAS(false);
        setFiltersSelectedValues({});
    };

    const getNewFilterOptionsData = async (uf, dataInicial, dataFinal) => {

        setRegionais([]);
        setCanaisDigitais([]);
        setAcoes([]);
        setSolucoes([]);

        setFilters((f) => ({
            ...f,
            canalDigital: null,
            acao: null,
            solucao: null,
            regionalProjetoAcao: null,
        }));

        Promise.all([
            AtendimentosSSEService.getFilterSolucoes(uf, dataInicial, dataFinal),
            AtendimentosSSEService.getFilterCanaisDigitais(uf, dataInicial, dataFinal),
            AtendimentosSSEService.getFilterRegionais(uf, dataInicial, dataFinal),
            AtendimentosSSEService.getFilterAcoes(uf, dataInicial, dataFinal),
        ]).then(([solucoesRes, canaisRes, regionaisRes, acoesRes]) => {
            if(regionaisRes.length) setRegionais(regionaisRes)
            if(canaisRes.length) setCanaisDigitais(canaisRes)
            if(acoesRes.length) setAcoes(acoesRes)
            if(solucoesRes.length) setSolucoes(solucoesRes)
        });
    };

    const getFiltersByUf = async (ufId) => {
        const data = await AtendimentosSSEService.getAtendimentosOpcoesPorUf(ufId);
        setFilterOptions(prevState => ({
            ufs: prevState.ufs,
            anos: prevState.anos,
            meses: prevState.meses,
            ...data,
        }));
        if(data.cidades) {
            setCidades(data.cidades);
        }
    };

    const getCidades = async (id) => {
        updateSelectedValues('ufs', id);
        updateSelectedValues('cidades', '');
        setCidades([]);
        if (id !== 'Todas' && filterOptions.ufs) {
            const uf = filterOptions.ufs.find((u) => u.id === parseInt(id));
            const cidadesByUF = filterOptions?.cidades?.filter((cd) => cd.uf.id === parseInt(id));
            setFilters((f) => ({
                ...f,
                ufs: props !== 'diagnostico/devolutiva/consultar' ? [uf] : uf.sigla,
                cidades: null,
            }));
            setCidades(cidadesByUF ?? []);
        } else {
            setFiltersDashboard((f) => ({ ...f, ufs: null, cidades: null }));
            setFilters((f) => ({ ...f, ufs: null, cidades: null }));
            setCidades([]);
        }
    };

    useEffect(() => {
        if (filtersDashboard.ufValueSelect && filterOptions.ufs) {
            getCidades(filtersDashboard?.ufValueSelect?.id);
        }
        // eslint-disable-next-line
    }, [filtersDashboard, filterOptions]);

    const cleanFilters = () => {
        const DEFAULT_VALUE_SELECIONE = 'Selecione';
        const backupVal = { ...filters };

        return Object.keys(backupVal)
            .filter(key => {
                const value = Array.isArray(backupVal[key]) ? backupVal[key][0] : backupVal[key];
                return value === false || (value && value !== DEFAULT_VALUE_SELECIONE);
            })
            .reduce((result, key) => ({
                ...result,
                [key]: backupVal[key],
            }), {});
    };

    // START HANDLEAREA FILTROS
    function handleDTInicioChange(newDTInicio) {
        setFiltersDashboard({
            ...filtersDashboard,
            dataInicial: null,
        });
        const ufSigla = filters?.ufs?.[0]?.sigla
        getNewFilterOptionsData(ufSigla, newDTInicio, filters.dataFinal)
        updateSelectedValues('dataInicial', newDTInicio);
        setFilters((f) => ({ ...f, dataInicial: newDTInicio }));
    }

    function handleDTFimChange(newDTFim) {
        setFiltersDashboard({
            ...filtersDashboard,
            dataFinal: null,
        });
        const ufSigla = filters?.ufs?.[0]?.sigla
        getNewFilterOptionsData(ufSigla, filters.dataInicial, newDTFim)
        updateSelectedValues('dataFinal', newDTFim);
        setFilters((f) => ({ ...f, dataFinal: newDTFim }));
    }

    function handleMesChange(newMes) {
        updateSelectedValues('mes', newMes);
        setFilters((f) => ({ ...f, mes: newMes }));
    }

    function handleAnoChange(newAno) {
        updateSelectedValues('ano', newAno);
        setFilters((f) => ({ ...f, ano: newAno }));
    }

    function handleUFConsolidadoChange(newUfConsolidado) {
        updateSelectedValues('uf', newUfConsolidado);
        setFilters((f) => ({
            ...f,
            uf: {
                id: Number(newUfConsolidado),
            },
        }));
    }

    function handleUFChange(newUF) {
        setFiltersDashboard({
            ...filtersDashboard,
            ufs: null,
        });
        const filteredUf = filterOptions?.ufs?.filter(i => (Number(i.id) === Number(newUF)) || (i.sigla === newUF))[0]
        updateSelectedValues('ufs', filteredUf?.id);
        handleFilterChangeProp('ufs', [filteredUf]);
        // getCidades(filteredUf?.id);
        getFiltersByUf(filteredUf?.id);
        getNewFilterOptionsData(filteredUf?.sigla, filters?.dataInicial, filters?.dataFinal)
    }

    function handleUFChangeDiagnostico(newUF) {
        const filteredUf = filterOptions?.ufs?.filter(i => (Number(i.id) === Number(newUF)) || (i.sigla === newUF))[0]
        getCidades(filteredUf?.id);
        updateSelectedValues('ufs', filteredUf?.id);
        handleFilterChangeProp('ufs', filteredUf?.sigla);
    }

    function handleUFEventoChange(newUF) {
        updateSelectedValues('uf', newUF);
        setFilters((f) => ({ ...f, uf: newUF }));
    }

    function handleCidadeChange(newUF) {
        setFiltersDashboard({ ...filtersDashboard, cidades: null, });
        const id = newUF;
        const recovery = cidades?.find((each) => each?.id === parseInt(id));
        if (!recovery) {
            updateSelectedValues('cidades', '');
            setFilters((f) => ({
                ...f, cidades: '',
            }));
            return;
        }
        updateSelectedValues('cidades', recovery?.id);
        setFilters((f) => ({
            ...f,
            cidades:
                props !== 'diagnostico/devolutiva/consultar'
                    ? [recovery]
                    : recovery.nome,
        }));
    }

    function handleCidadeChangeDiagnostico(newUF) {
        setFiltersDashboard({ ...filtersDashboard, cidades: null, });
        const id = newUF;
        const recovery = cidades?.find((each) => each?.id === parseInt(id));
        if (!recovery) {
            updateSelectedValues('cidades', '');
            setFilters((f) => ({
                ...f, cidades: '',
            }));
            return;
        }
        updateSelectedValues('cidades', recovery?.id);
        setFilters((f) => ({
            ...f,
            cidades: recovery.nome,
        }));

    }

    function handleUserQueChange(newUserQue) {
        handleFilterChange('usuariosQue', newUserQue);
    }

    function handleTipoUserChange(newTipoUser) {
        if (newTipoUser === 'cpf') {
            setIsCPF(true);
            setIsALL(false);
            setIsCNPJ(false);
            setFilters((f) => ({ ...f, tipoPessoa: 'PESSOA_FISICA' }));
        } else if (newTipoUser === 'cnpj') {
            setIsCPF(false);
            setIsALL(false);
            setIsCNPJ(true);
            setFilters((f) => ({ ...f, tipoPessoa: 'PESSOA_JURIDICA' }));
        } else if (newTipoUser === 'isAll') {
            setIsALL(true);
            setIsCPF(false);
            setIsCNPJ(false);
            setFilters((f) => ({ ...f, tipoPessoa: 'TODAS' }));
        }
    }

    function handleErroSASChange(isErroSAS) {
        if (isErroSAS === 'allSas') {
            setIsErroSAS(false);
            setIsntErroSAS(false);
            setAllSAS(true);
            setFilters((f) => ({ ...f, envioSas: null }));
        } else if (isErroSAS === 'erroSAS') {
            setIsErroSAS(true);
            setIsntErroSAS(false);
            setAllSAS(false);
            setFilters((f) => ({ ...f, envioSas: true }));
        } else if (isErroSAS === 'noErroSAS') {
            setIsErroSAS(false);
            setIsntErroSAS(true);
            setAllSAS(false);
            setFilters((f) => ({ ...f, envioSas: false }));
        }
    }

    function handleCanalChange(newCanal) {
        const recoveryAtendente = filterOptions.atendentes.find(
            (each) => each.id === parseInt(newCanal)
        );
        handleFilterChange('atendentes', recoveryAtendente);
    }

    function handleAtendenteConsolidadeChange(newCanal) {
        const recoveryAtendente = filterOptions.atendentes.find(
            (each) => each.id === parseInt(newCanal)
        );
        handleFilterChange('atendente', recoveryAtendente);
    }

    function handleInteracaoChange(newInteracao) {
        handleFilterChange('interacao', newInteracao);
    }

    function handlePorteChange(newPorte) {
        const id = newPorte;
        const recoveryPortes = filterOptions.portes.find((each) => each.id === parseInt(id));
        updateSelectedValues('portes', id);
        setFilters((f) => ({ ...f, portes: [recoveryPortes] }));
    }

    function handleSegmentosChange(newSegmentos) {
        const id = newSegmentos;
        const recoverySegmentos = filterOptions.segmentos.find(
            (each) => each.id === parseInt(id)
        );
        updateSelectedValues('segmentos', id);

        setCnaesFiltered(
            id !== ''
                ? filterOptions.cnaes.filter(
                    (cn) => cn.segmento === recoverySegmentos.nome
                )
                : []
        );
        setFilters((f) => ({ ...f, segmentos: [recoverySegmentos] }));
    }

    function handleCNAEChange(newCNAE) {
        const id = newCNAE;
        const recoveryCnae = filterOptions.cnaes.find(
            (each) => each.id === parseInt(id)
        );
        updateSelectedValues('cnaes', id);
        setFilters((f) => ({ ...f, cnaes: [recoveryCnae] }));
    }

    function handleAtendentesChange(newAtendente) {
        updateSelectedValues('atendente', newAtendente);
        const recovery = filterOptions.atendentes.find(
            (each) => each.id === parseInt(newAtendente)
        );
        setFilters((f) => ({ ...f, atendente: recovery }));
    }

    function handleTipoAtendimentoChange(newTipoAtendimento) {
        const recovery = filterOptions.tiposRealizacao.find(
            (each) => each.id === parseInt(newTipoAtendimento)
        );

        updateSelectedValues('tipoRealizacao', newTipoAtendimento);
        setFilters((f) => ({ ...f, tipoRealizacao: recovery }));
    }

    function handleInstrumentoChange(newInstrumento) {
        handleFilterChange('instrumento', newInstrumento);
    }

    function handleTempoAcessoChange(newTempoAcesso) {
        handleFilterChange('tempoAcesso', newTempoAcesso);
    }

    function handleHrEnvioChange(newHrEnvio) {
        handleFilterChange('horarioEnvio', newHrEnvio);
    }

    function handleRecorrenciaChange(newRecorrencia) {
        handleFilterChange('recorrencia', newRecorrencia);
    }

    function handleDiagnosticoChange(newDiagnostico) {
        handleFilterChange('nomeDiagnostico', newDiagnostico);
    }

    function handleEventoChange(newEvento) {
        handleFilterChange('nomeEvento', newEvento);
    }

    function handleCanalDiagnosticoChange(newCanal) {
        handleFilterChange('canal', newCanal);
    }

    function handlePrimeiroAcessoChange(newPrimeiroAcesso) {
        handleFilterChange('primeiroAcesso', newPrimeiroAcesso);
    }

    function handleUltimoAcessoChange(newUltimoAcesso) {
        handleFilterChange('ultimoAcesso', newUltimoAcesso);
    }

    function handleQtdAcessoChange(newQtdAcesso) {
        handleFilterChange('quantidadeAcessos', newQtdAcesso);
    }

    function handlePerfilChange(newPerfil) {
        handleFilterChange('perfil', newPerfil);
    }

    function handleSetFilters(event) {
        // setFilters((f) => ({ ...f, ano: newAno }));
        setFilters({
            type: 'order',
            data: {
                name:
                    event === 'dataPrimeiroAcesso'
                        ? 'PrimeiroAcesso'
                        : event === 'uf'
                            ? 'sigla'
                            : event,
                orderType:
                    event === filters.order.name ? !filters.order.orderType : true,
            },
        });
    }

    function handleTemaChangeFilter(tema) {
        handleFilterChange('tema', tema);
    }


    function handleFilterChange(name, value) {
        updateSelectedValues(name, value);
        setFilters((f) => ({ ...f, [name]: value }));
    }

    function handleFilterChangeProp(name, value) {
        setFilters((f) => ({ ...f, [name]: value }));
    }

    function resetPaginationFilters() {
        setPaginationFilters({
            page: 0,
            linesPerPage: 10,
            orderBy: 'id',
            direction: 'DESC',
        })
    }


    function resetFiltersProps(prop) {
        if (!prop) return;
        setFilters(prevState => {
            const updatedFilters = { ...prevState };
            const filtered = Object.keys(updatedFilters).filter(i => i !== prop);
            return filtered
        })

        setFiltersSelectedValues(prevState => {
            const updatedFilters = { ...prevState };
            return Object.keys(updatedFilters).filter(i => i !== prop);
        })
    }

    function handleClearNewFilters () {
        setRegionais([]);
        setCanaisDigitais([]);
        setAcoes([]);
        setSolucoes([]);
    }

    // END HANDLEAREA FILTROS
    // ___________________________________________________________________________

    return {
        resetPaginationFilters,
        handleClearNewFilters,
        resetFiltersProps,
        handleOrderClick,
        handleInputPageChange,
        handleFilterByStatus,
        handlePageChange,
        onLinesPerPageChange,
        filters,
        setFilters,
        paginationFilters,
        setPaginationFilters,
        inputSearchValue,
        setInputSearchValue,
        isLoading,
        setIsLoading,
        pendants,
        setPendants,
        filterOptions,
        setFilterOptions,
        filterOptionsConsolidado,
        setFilterOptionsConsolidado,
        showModal,
        cleanSelectedFiltersFromModel,
        cleanFilters,

        // handleFiltros
        handleDTInicioChange,
        handleDTFimChange,
        handleMesChange,
        handleAnoChange,
        handleUFChange,
        handleUFConsolidadoChange,
        handleUFEventoChange,
        handleCidadeChange,
        handleUserQueChange,
        handleTipoUserChange,
        handleErroSASChange,
        handleCanalChange,
        handleAtendenteConsolidadeChange,
        handleInteracaoChange,
        handlePorteChange,
        handleSegmentosChange,
        handleCNAEChange,
        handleAtendentesChange,
        handleTipoAtendimentoChange,
        handleInstrumentoChange,
        handleTempoAcessoChange,
        handleHrEnvioChange,
        handleRecorrenciaChange,
        handleDiagnosticoChange,
        handleEventoChange,
        handleCanalDiagnosticoChange,
        handlePrimeiroAcessoChange,
        handleUltimoAcessoChange,
        handleQtdAcessoChange,
        handlePerfilChange,
        handleSetFilters,
        handleTemaChangeFilter,
        handleFilterChange,
        handleUFChangeDiagnostico,
        handleCidadeChangeDiagnostico,
        // CONSTANTS
        isCPF,
        isALL,
        isCNPJ,
        isErroSAS,
        isntErroSAS,
        allSAS,
        cnaesFiltered,
        filtersSelectedValues,
        cidades,
        regionais,
        canaisDigitais,
        acoes,
        solucoes,
    };
};
